//-- copyright
// OpenProject is an open source project management software.
// Copyright (C) the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
//
// See COPYRIGHT and LICENSE files for more details.
//++

import { Injectable, inject } from '@angular/core';
import { interval } from 'rxjs';
import { filter, startWith, switchMap } from 'rxjs/operators';
import { ActiveWindowService } from 'core-app/core/active-window/active-window.service';
import { ApiV3Service } from 'core-app/core/apiv3/api-v3.service';

const POLLING_INTERVAL = 2000;

@Injectable()
export class QueryUpdatedService {
  readonly activeWindow = inject(ActiveWindowService);
  readonly apiV3Service = inject(ApiV3Service);


  public monitor(ids:string[]) {
    let time = new Date();

    return interval(POLLING_INTERVAL)
      .pipe(
        startWith(0),
        filter(() => ids.length > 0),
        filter(() => this.activeWindow.isActive),
        switchMap(() => {
          const result = this.queryForUpdates(ids, time);

          time = new Date();

          return result;
        }),
        filter((collection) => collection.count > 0),
      );
  }

  private queryForUpdates(ids:string[], updatedAfter:Date) {
    return this
      .apiV3Service
      .queries
      .list({
        filters: [['id', '=', ids],
          ['updatedAt', '<>d', [updatedAfter.toISOString()]]],
      });
  }
}
